module.exports = __webpack_public_path__ + "img/audio.289bda75.svg";